export const defaultOptions = {
    gap: 5, // px
    loop: false,
    navigation: true,
    numeration: false,
    reserveTailSpace: false,
    tailWidth: 0 // % - Lugano changes
};

// if numeration has some specific font family, proportions can be customized via window.Playtech.Variables.carousel.numeration
export const MAX_NUMERATION_FONT_SIZE = window.Playtech?.Variables?.carousel?.numeration?.maxFontSize || 170; // px
export const MAX_NUMERATION_WIDTH = window.Playtech?.Variables?.carousel?.numeration?.maxWidth || 100; // px
export const NUMERATION_WIDTH_RATIO = MAX_NUMERATION_WIDTH / MAX_NUMERATION_FONT_SIZE;
